// extracted by mini-css-extract-plugin
export default {"document_upload":"DocumentUpload_document_upload__f6mzM","field":"DocumentUpload_field__paDoV","btn":"DocumentUpload_btn__mWwxs"};